import { appointmentFormValidFields } from './schema';

export const isAppointmentFormField = (
  field: unknown,
): field is (typeof appointmentFormValidFields)[number] => {
  return (
    typeof field === 'string' &&
    appointmentFormValidFields?.includes(
      field as (typeof appointmentFormValidFields)[number],
    )
  );
};
